import { applyStyle } from '../css';
import { appState } from '../../state';
import { createSidebar, defaultNavGroups } from './sidebar';
import { createTopbar } from './topbar';
/**
 * Sidebar + topbar + content slot wrapper. Authenticated tüm sayfalar bunun
 * içinde render olur. Login/Session full-bleed olduğu için bu helper'ı
 * çağırmaz.
 *
 * Mobile responsive: sidebar ≤768px'de off-canvas drawer; topbar'daki
 * hamburger butonu drawer'ı toggle eder. CSS class hooks (`pr-sidebar`,
 * `pr-sidebar--open`, `pr-sidebar-overlay`) tokens.css'te media queries
 * ile gizlenir/gösterilir.
 */
export function withShell(opts) {
    const root = document.createElement('div');
    root.classList.add('pr-shell');
    applyStyle(root, {
        color: 'var(--text-primary)',
        fontFamily: 'var(--font-sans)',
    });
    // Mobile drawer overlay (sidebar arkası)
    const overlay = document.createElement('div');
    overlay.classList.add('pr-sidebar-overlay');
    overlay.addEventListener('click', () => closeDrawer());
    const sidebar = createSidebar({
        groups: defaultNavGroups(),
        activeRoute: opts.activeRoute,
        onNavigate: (route) => {
            closeDrawer();
            appState.navigate(route);
        },
        userEmail: appState.userEmail,
        version: opts.version,
        onLogout: () => appState.logout(),
    });
    sidebar.classList.add('pr-sidebar');
    root.append(overlay, sidebar);
    const main = document.createElement('main');
    main.classList.add('pr-main');
    applyStyle(main, {
        background: 'var(--bg-base)',
    });
    main.append(createTopbar({
        breadcrumbs: opts.breadcrumbs,
        searchPlaceholder: opts.searchPlaceholder,
        connection: opts.connection ?? { connected: true, latencyMs: 28 },
        onMenuToggle: () => toggleDrawer(),
    }));
    const contentWrap = document.createElement('div');
    contentWrap.classList.add('pr-content-wrap');
    if (opts.fullBleed)
        contentWrap.classList.add('pr-content-wrap--full');
    contentWrap.append(opts.content);
    main.append(contentWrap);
    root.append(main);
    function openDrawer() {
        sidebar.classList.add('pr-sidebar--open');
        overlay.classList.add('pr-sidebar-overlay--open');
        document.body.classList.add('pr-no-scroll');
    }
    function closeDrawer() {
        sidebar.classList.remove('pr-sidebar--open');
        overlay.classList.remove('pr-sidebar-overlay--open');
        document.body.classList.remove('pr-no-scroll');
    }
    function toggleDrawer() {
        if (sidebar.classList.contains('pr-sidebar--open'))
            closeDrawer();
        else
            openDrawer();
    }
    // Pencere büyürse drawer state'i sıfırla (≤768px → >768px geçişte)
    const mq = window.matchMedia('(max-width: 768px)');
    mq.addEventListener?.('change', (ev) => {
        if (!ev.matches)
            closeDrawer();
    });
    return root;
}
